export interface GetCollectionOrderEditInfoRequest {
  orderIds: number[]
}

export function GetCollectionOrderEditInfoRequestToJSON(
  value: GetCollectionOrderEditInfoRequest
): any {
  return {
    order_ids: value.orderIds.length > 0 ? value.orderIds : undefined
  }
}
